import { useMutation } from '@tanstack/react-query';

import useStore from 'services/store';
import { useApi } from 'services/api';
import { fileDownload } from 'utils/download';
import { getConfiguredTimezone } from 'utils/datetime';

const useDownloadRecords = () => {
  const api = useApi();
  const activeSensorsByProfile = useStore((state) => state.searchQuery.activeSensorsByProfile);
  const timezone = getConfiguredTimezone();

  const {
    isPending: isLoading,
    mutate,
    error,
  } = useMutation({
    mutationFn: ({ pqlQuery, context, searchType, type }) => {
      return api.get(`/search/query/${type}`, {
        params: {
          query: pqlQuery,
          timezone,
          searchType,
          context: context || activeSensorsByProfile || [],
        },
        headers: {
          Accept: type === 'csv' ? 'text/csv' : 'application/json',
        },
      });
    },
    onSuccess: (data, { pqlQuery, fileName = pqlQuery, type }) => {
      fileDownload(
        type === 'csv' ? data : JSON.stringify(data, null, 2),
        `${fileName}.${type}`,
        type === 'csv' ? 'text/csv' : 'application/json',
      );
    },
  });

  return {
    isLoading,
    downloadRecords: mutate,
    error,
  };
};

export default useDownloadRecords;
